import moment from "moment";
import React from "react";
// import { listGood_listGood_goods } from "../__generated__/listGood";
// import { listGoodOption_listGoodOption_goodOptions } from "../__generated__/listGoodOption";
import { ListGood } from "../routes/admin-list-product";

interface ExpirydateProps {
  data: ListGood;
}

export const ComponentExpirydate: React.FC<ExpirydateProps> = ({ data }) => {
  return (
    <table className="w-full">
      <thead></thead>
      <tbody>
        {/* {!data.goodStocks ||
          (data.goodStocks.length === 0 && (
            <tr className=" border-b border-[#F9F8F9] h-8 text-center">
              <td colSpan={18} className="text-[#8B8C8C]">
                해당 정보가 없습니다.
              </td>
            </tr>
          ))} */}
      </tbody>
    </table>
  );
};
